// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-operations .ant-upload-list {\n  display: none;\n}\n.candidate-users {\n  width: 450px;\n}\n.ant-select-dropdown {\n  z-index: 99999999 !important;\n}\n", ""]);
// Exports
module.exports = exports;
